import { createRouter, createWebHashHistory } from 'vue-router'
import Index from '../views/Home.vue'
import FAQS from '../views/FAQS.vue'
import Contact from '../views/Contact.vue'
import Login from '../views/Login.vue'
import Datos from '../views/Datos.vue'

import auth from '../auth/auth.js'


//import Maintance from '../views/Maintance.vue'

const routes = [
    /*{
      path: '*',
      name: 'Sitio en mantenimiento',
      component: '../views/Maintance.vue'
    },*/
    {
        path: '/',
        name: 'Cáncer de mama | SSNL',
        component: Index
    },
    {
        path: '/faqs',
        name: 'Preguntas frecuentes',
        component: FAQS
    },
    {
        path: '/contact',
        name: "Contacto",
        component: Contact
    },
    {
        path: '/login',
        name: 'Iniciar sesión',
        component: Login
    },
    {
        path: '/datos',
        name: 'Datos',
        component: Datos,
        beforeEnter: (to, from, next) => {
            if (auth.isUserLogged()) {
                next();
            } else {
                next("/login");
            }
        },
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

/*https://stackoverflow.com/a/69513429/5767989*/
router.beforeEach((to, from, next) => {
    document.title = to.name;
    next();
})

export default router